#import "../../list/DataAccessPolicyFields.graphql"

mutation DataAccessPolicyUpdate($input: DataAccessPolicyUpdateInput!) {
  dataAccessPolicyUpdate(input: $input) {
    dataAccessPolicy {
      ...DataAccessPolicyFields
    }
  }
}
